/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactItemDto } from './subjectContactItemDto.model';


export interface BarterListItemDto { 
    barterNumber?: number;
    barterNumberOfficial?: string;
    barterYear?: number;
    counterparty?: SubjectContactItemDto;
    efficiencyFromDate?: string;
    expirationDate?: string;
    id?: number;
    invalid?: boolean;
    invalidExplanation?: string;
    invalidGrayed?: boolean;
    stateName?: string;
    sumConcernedAcreage?: number;
}

